import axios from 'axios';
import { GroupDto } from '@/features/groups/group.dto';
import { ApiResult, ServiceResponse } from '@/OptimusRoutes/interfaces';

type Service = {
	get: () => Promise<ServiceResponse<ApiResult<GroupDto[]>>>;
	create: (group: Partial<GroupDto>) => Promise<ServiceResponse<GroupDto>>;
	edit: (group: Partial<GroupDto>) => Promise<ServiceResponse<GroupDto>>;
	delete: (id: number) => Promise<ServiceResponse>;
	unShare: (id: number) => Promise<ServiceResponse>;
};

const get = async (): Promise<ServiceResponse<ApiResult<GroupDto[]>>> => {
	const { data } = await axios.get<ServiceResponse<ApiResult<GroupDto[]>>>(`/v2/group`);
	return data;
};

const create = async (group: Partial<GroupDto>): Promise<ServiceResponse<GroupDto>> => {
	const { data } = await axios.post<ServiceResponse<GroupDto>>(`/v2/group`, group);
	return data;
};
const edit = async ({ id, ...group }: Partial<GroupDto>): Promise<ServiceResponse<GroupDto>> => {
	const { data } = await axios.patch<ServiceResponse<GroupDto>>(`/v2/group/${id}`, group);
	return data;
};
const remove = async (id: number): Promise<ServiceResponse> => {
	const { data } = await axios.delete<ServiceResponse>(`/v2/group/${id}`);
	return data;
};

const unShare = async (id: number): Promise<ServiceResponse> => {
	const { data } = await axios.patch<ServiceResponse>(`/v2/group/${id}/unShare`);
	return data;
};

const GroupsService: Service = {
	get,
	create,
	edit,
	delete: remove,
	unShare,
};

export default GroupsService;
